import React, { useMemo } from 'react';
import { formatDate, formatDateEur } from '../../../shared/utility';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { SIProgressLine, SIProgressLineBar, SIProgressLineItem, SIProgressLineItemTitle } from './StatusProgressLine.styled';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import LinearProgress from '@mui/material/LinearProgress';
function StatusProgressLine({ status, typeCampagne, activee, reference, endDate, dateOuvertureOps, dateFermetureOps, dateOuvertureSls, dateFermetureSls }) {
  const theme = useTheme();
  const { t } = useTranslation()
  const statutOps = formatDateEur(new Date(dateOuvertureOps)) > formatDateEur(new Date()) ? "scheduled" : formatDateEur(new Date()) >= formatDateEur(new Date(dateFermetureOps)) ? "completed" : "inProgress"
  const statutSls = formatDateEur(new Date(dateOuvertureSls)) > formatDateEur(new Date()) ? "scheduled" : formatDateEur(new Date()) >= formatDateEur(new Date(dateFermetureSls)) ? "completed" : "inProgress"

  const statusList = useMemo(() => {
    if (typeCampagne === 0) {
      return  [
                { type: "SLS :", title: " Du " + formatDate(new Date(dateOuvertureSls)) + '   Au  ' + formatDate(new Date(dateFermetureSls)), dateDebut: dateOuvertureSls, dateFin: dateFermetureSls, value: statutSls },
                { type: "OPS :", title: " Du " + formatDate(new Date(dateOuvertureOps)) + '   Au  ' + formatDate(new Date(dateFermetureOps)), dateDebut: dateOuvertureOps, dateFin: dateFermetureOps, value: statutOps },
              ]
    } else {
      return  [
        { type: "Attestations d'assurance :", title: " Du " + formatDate(new Date(dateOuvertureSls)) + '   Au  ' + formatDate(new Date(dateFermetureSls)), dateDebut: dateOuvertureSls, dateFin: dateFermetureSls, value: "scheduled" },
              ]
    }
  }, [typeCampagne]);
   
  
    const calculerProgression=(dateDebutStr, dateFinStr)=> {
        const debut = new Date(dateDebutStr);
        const fin = new Date(dateFinStr);
        const maintenant = new Date();

        const total = fin - debut; // durée totale en ms
        const passe = maintenant - debut; // temps déjà écoulé en ms

        if (maintenant <= debut) return 0;
        if (maintenant >= fin) return 100;
       
        return Math.round((passe / total) * 100);
    }
    const getStatusColor = (value, index) => {
        const statusIndex = statusList?.findIndex(item => item?.value?.toUpperCase() === status?.toUpperCase())
        if (status?.toUpperCase() === "completed".toUpperCase())
            return theme.colors.secondary;

        if (value?.toUpperCase() === status?.toUpperCase())
            return theme.colors.secondary;

        if (index < statusIndex)
            return theme.colors.secondary;

        return theme.colors.gray;
    }

    const showProgressLineBar = (value, index) => {
        //const statusIndex = statusList?.findIndex(item => item?.value?.toUpperCase() === status?.toUpperCase());
        return index <2;
    }


    const getStatusColors = (value, index) => {

        let statusIndex = statusList.filter(item => item.show).findIndex(item => item.value === infoStatus)
        if (statusIndex == 0)
            statusIndex = 1;
        
        if (value == "completed")
            return [theme.colors.secondary, " solid " + theme.colors.secondary]
          
        if (value =="inProgress")
            return [theme.colors.lightBlue, " dashed " + theme.colors.lightBlue]
        if (value == "scheduled")//si programmé
            return [theme.colors.secondary, " dashed " + theme.colors.secondary]

      /*  return [theme.colors.secondary, " solid " + theme.colors.gray]*/
    }
    calculerProgression(dateOuvertureOps, dateFermetureOps)
    return (
        <>
            <SIProgressLine>
                {
                    statusList.map((item, index) => (
                      <SIProgressLineItem style={typeCampagne === 1 ? { width: '100%' } : {}}
                            key={index}
                        >
                            <SIProgressLineItemTitle
                            >
                                <span style={{ fontWeight:"bold" }}>{item.type}</span>
                                <span style={{ color: theme.colors.secondary }}>
                                    {item.title}
                                </span>
                            </SIProgressLineItemTitle>
                            {
                                <div style={{} }>
                            <LinearProgress variant="determinate" sx={{ height: 9, borderRadius: '5px' }} value={typeCampagne==1 ? 58:calculerProgression(item.dateDebut, item.dateFin)} />
                                </div>
                            }
                        </SIProgressLineItem>
                    ))
                    
                }


                
            </SIProgressLine>
            
        </>
    );
}

export default StatusProgressLine;
